import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';

export const MEM_BASIC_Schema = {
  fields: {
    no: { initial: '', label: 'No' },
    depCd: {
      initial: '',
      label: '부서 코드',
    },
    depNm1: { initial: '', label: '본부', required: 'Y' },
    depNm2: { initial: '', label: '부서' },
    depNm3: { initial: '', label: '팀' },
    depNm4: { initial: '', label: '파트' },

    authNm: { initial: '기본', label: '권한' },
    position: { initial: '', label: '직위' },
    rank: { initial: '', label: '직급' },
    name: { initial: '', label: '성명', required: 'Y' },
    id: { initial: '', label: 'ID' },
    /** 0: 내부인, 1: 외부인 */
    internalYn: { initial: '0', label: '회원유형', required: 'Y' },
    affiliationNm: { initial: '', label: '소속' },
    tel: { initial: '', label: '전화번호' },
    birth: { initial: '', label: '생년월일' },
    bloodType: { initial: 'A', label: '혈액형' },
    address: { initial: '', label: '주소' },
    nation: { initial: '대한민국', label: '국적' },
    useYn: { initial: 'Y', label: '활성화 여부' },
  },

  mapper: {
    search1: {
      UserId: (_, context) => context.userInfo.userid,
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo.authCd),
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo.coCd),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText),
    },
    search2: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText),
    },

    search3: {
      CoCd: (_, context) => {
        const { userInfo, search } = context;
        const coCd =
          userInfo?.authCd === 'ADMIN' ? search?.coCd : userInfo?.coCd;
        return Commons.EncryptAES(coCd);
      },
    },
    search4: {
      CoCd: (_, context) => {
        const { userInfo, search } = context;
        const coCd =
          userInfo?.authCd === 'ADMIN' ? search?.coCd : userInfo?.coCd;
        return Commons.EncryptAES(coCd);
      },
    },
    search5: {
      UserId: (_, context) => context.userInfo.userid,
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo.authCd),
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo.coCd),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },
    save1: {
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd
        ),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      UserId: (_, context) => context.userInfo?.userid,
      Id: (row) => Commons.EncryptAES(row.id),
      EmployeeNo: (row) => Commons.EncryptAES(String(row.employeeNo ?? '')),
      InternalYn: (row) => {
        const v = row.internalYn;
        const flag = v === 1 || v === '1' || v === true ? '1' : '0';
        return Commons.EncryptAES(flag);
      },
      AffiliationNm: (row) =>
        Commons.EncryptAES(String(row.affiliationNm ?? '')),
      ProperName: (_, context) =>
        Commons.EncryptAES(String(context.getProperName?.(context) ?? '')),
      DepNm1: (row) => Commons.EncryptAES(String(row.depNm1 ?? '')),
      DepNm2: (row) => Commons.EncryptAES(String(row.depNm2 ?? '')),
      DepNm3: (row) => Commons.EncryptAES(String(row.depNm3 ?? '')),
      DepNm4: (row) => Commons.EncryptAES(String(row.depNm4 ?? '')),
      AuthCd: (row, context) => {
        const authNm = row.authNm || '기본';
        const authCd = context.getAuthCd?.(authNm, context);
        return Commons.EncryptAES(String(authCd ?? ''));
      },

      UseYn: (row) => Commons.EncryptAES(String(row.useYn ?? 'Y')),
      Position: (row) => Commons.EncryptAES(String(row.position ?? '')),
      Rank: (row) => Commons.EncryptAES(String(row.rank ?? '')),
      Name: (row) => Commons.EncryptAES(String(row.name ?? '')),
      Tel: (row) => Commons.EncryptAES(String(row.tel ?? '')),

      Birth: (row) =>
        Commons.EncryptAES(
          row.birth
            ? dayjs(row.birth).format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD')
        ),

      BloodType: (row) => Commons.EncryptAES(String(row.bloodType ?? '')),
      Address: (row) => Commons.EncryptAES(String(row.address ?? '')),
      Nation: (row) => Commons.EncryptAES(String(row.nation ?? '대한민국')),
      TbmYn: (row) => Commons.EncryptAES(String('N')),
      ApprovalYn: (row) => Commons.EncryptAES(String('N')),
    },

    save2: {
      CustCd: (_, context) => Commons.EncryptAES(context.custCd ?? ''),
      UserId: (_, context) => context.userId ?? '',
    },

    save3: {
      UserId: (_, context) => context.userId ?? '',
      AuthCd: (_, context) => Commons.EncryptAES(context.authCd ?? ''),
      CoCd: (_, context) => Commons.EncryptAES(context.coCd ?? ''),
      Approve: (_, context) => Commons.EncryptAES(context.approve ?? '0'),
      Id: (row) => Commons.EncryptAES(row.id ?? ''),
    },
    save4: {
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd
        ),
      CpNm: (row) => Commons.EncryptAES(row.cpNm ?? ''),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    save5: {
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd
        ),
      CustCd: (row) => Commons.EncryptAES(row.custCd ?? ''),
      DepCd: (row) => Commons.EncryptAES(row.depCd ?? ''),
      Id: (row) => Commons.EncryptAES(row.id ?? ''),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    save6: {
      CustCd: (row) => Commons.EncryptAES(row.custCd ?? ''),
      DepCd: (row) => Commons.EncryptAES(row.depCd ?? ''),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    delete1: {
      CoCd: (row) => Commons.EncryptAES(row.coCd),
      Id: (row) => Commons.EncryptAES(row.id),
    },
  },
};
